export const getLottieOptions = ({ loop = true, autoplay = true, rendererSettings, animationData }) => ({
  loop,
  autoplay,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
    ...rendererSettings
  }
});
